<template>
    <custom-node>
        <template #icon>
            <svg-icon
                class="node-icon"
                :icon="IconClock"
                color="#eda669"
                is-custom-icon
            />
        </template>

        <template #content>
            <flex-container>
                <h2>Wachten</h2>
                <span v-if="false" v-tooltip.info="'Lorem ipsum'">
                    <svg-icon
                        :icon="IconCircleInfo"
                        is-custom-icon
                    />
                </span>
            </flex-container>
            <p>{{ duration }}</p>
        </template>
    </custom-node>
</template>

<script setup lang="ts">
    import { FlexContainer, SvgIcon } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import type { Node } from '@keyvue/one-api-client';
    import CustomNode from '@/flow/flow/components/graph/custom-types/CustomNode.vue';

    import IconClock from '@keyvue/one-awesome-icons/icons/sharp-regular/clock.svg?component';
    import IconCircleInfo from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';
    import { translateTimingUnit } from '@/flow/flow/utils/flow-types';

    interface Props {
        data: Node
    }

    const props = defineProps<Props>();

    const duration = computed(() => {
        const quantity = props.data.options.intervalQuantity;
        const unit = translateTimingUnit(props.data.options.intervalUnit, quantity);

        return `${quantity} ${unit}`;
    });
</script>

<style scoped lang="scss">
.custom-node {
    &[selected="false"] {
        :deep(.custom-node__visual) {
            background-color: #eda669;

            &:hover {
                background-color: #ED6E2D;

                :deep(.node-icon) {
                    color: #ED6E2D;
                }
            }
        }
    }
}
</style>
